import { STTableProp } from '../STTableProps';
import { TableCell, IconButton, Stack, Grid } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Checkbox,
} from "@mui/material";
import './CustomStyleST.css';
import { Fragment } from 'react';
import { Convert } from 'utilities/utilities';

export default function CreateRowTable(param: STTableProp, row: any, setOpen, open, index, arrColumnDefault, selectionModel, setSelectionModel, arrRowCollap, setarrRowCollap) {
  let arrLastColumn = param.columnmerge ? param.columnmerge[param.columnmerge.length - 1].column : arrColumnDefault;
  let arrColumn = param.columnmerge ? arrLastColumn : arrColumnDefault;
  const nPage = param.rows.nPageIndex + (param.DataMode === "client" ? 1 : 0);
  const maxRowSizePerPage = nPage * param.rows.nPageSize;
  let nRow = (index + 1) + maxRowSizePerPage;

  const handdleSetOpenRow = (ownRow) => {
    let isCheck = arrRowCollap.includes(row.nID);
    let arrTemp = arrRowCollap.filter((w) => w !== row.nID);

    if (!isCheck) {
      arrTemp.push(row.nID);
    }

    let arrRowsAll = param.rows.arrRows.filter(f => f.isCollapseHead);
    let arrRowsClone = arrRowsAll;

    arrRowsAll.forEach(f => {
      if (ownRow === f.nParentID) {
        arrRowsClone.forEach(item => {
          if (f.nID === item.nParentID) {
            arrTemp = arrTemp.filter((w) => w !== item.nID);
          }
        });

        arrTemp = arrTemp.filter((w) => w !== f.nID);
      }
    });

    setarrRowCollap([...new Set(arrTemp)]);
  }

  const CheckIcon = (row) => {
    return arrRowCollap.includes(row.nID) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />
  }

  return arrColumn.map((item) => (
    item.collapse ?
      <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 10 }}>
        {
          row.isCollapseChild ?
            <Fragment>
              <Stack direction={"row"}>
                <IconButton
                  id='BtnExpand'
                  aria-label="expand row"
                  size="small"
                  onClick={(e) => {
                    let nValue = Convert.StringToInt((e.target as HTMLInputElement).value);
                    if (nValue !== 0 && nValue !== row.nID) {
                      handdleSetOpenRow(nValue)
                    } else {
                      handdleSetOpenRow(row.nID)
                    }
                  }}
                >
                  {CheckIcon(row)}
                </IconButton>
                {item.getAction(row, nRow)}
              </Stack>
            </Fragment>
            :
            <Grid sx={{ ml: "2.3rem" }}>
              {item.getAction(row, nRow)}
            </Grid>
        }
      </TableCell> :
      item.colspanrow && row.nColSpan ?
        <TableCell
          key={param.sTableID + "_" + row.sID + "_" + item.field}
          height={52}
          colSpan={item.colspanrow ? row.nColSpan : null}
          style={item.width ? { width: item.width } : {}}
          className='tbCellBody'
        >
          {
            !item.collapse ? item.getAction ? item.getAction(row, nRow) : row[item.field]
              :
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
          }
        </TableCell>
        :
        !item.colspanrow && row.nColSpan ? null :

          <TableCell
            key={param.sTableID + "_" + row.sID + "_" + item.field}
            style={item.width ? { width: item.width } : {}}
            className='tbCellBody'
          >
            <div style={{ textAlign: item.bodyAlign }}>
              {
                !item.collapse ? item.getAction ? item.getAction(row, nRow) :
                  item.isCheckBox ?
                    <Checkbox
                      id={"ckHead_" + param.sTableID}
                      disabled={param.isView || row.isDisable === true}
                      checked={selectionModel.length > 0 && !(param.isView || row.isDisable === true) ? selectionModel.includes(row.sID) : false}
                      onChange={(e) => {
                        if (param.rows) {
                          let isCheck = e.target.checked;
                          let arrTemp = selectionModel.filter((w) => w !== row.sID);
                          if (!arrTemp) {
                            arrTemp = [];
                          }
                          if (isCheck) {
                            arrTemp.push(row.sID);
                          }
                          setSelectionModel(arrTemp);
                        }
                      }}
                    />
                    :
                    row[item.field]
                  :
                  row.collapse ?
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    :
                    null
              }
            </div>
          </TableCell>
  ))
}